import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "../../services/api.js";

export default function UpdateServiceModal({
  open,
  onClose,
  service,
  token,
  onSuccess,
}) {
  const [form, setForm] = useState({
    firstpaymentamount: "",
    recurringamount: "",
    billingcycle: "",
    nextduedate: "",
    username: "",
    password: "",
    notes: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (service) {
      setForm({
        firstpaymentamount: service.firstpaymentamount ?? "",
        recurringamount: service.recurringamount ?? "",
        billingcycle: service.billingcycle ?? "",
        nextduedate: service.nextduedate
          ? service.nextduedate.split("T")[0]
          : "",
        username: service.username ?? "",
        password: service.password ?? "",
        notes: service.notes ?? "",
      });
    }
  }, [service]);

  if (!open) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await api.put(
        `/subscribe-update/${service.id}`,
        {
          firstpaymentamount: form.firstpaymentamount,
          recurringamount: form.recurringamount,
          billingcycle: form.billingcycle,
          nextduedate: form.nextduedate,
          status: form.status,
          username: form.username,
          password: form.password,
          notes: form.notes,
        },
        {
          headers: { Authorization: token },
        }
      );

      onSuccess();
      onClose();
    } catch (err) {
      console.error("Update service failed:", err);
      alert("Failed to update service");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-lg rounded-lg bg-white dark:bg-gray-900 p-6 shadow-xl"
      >
        <h3 className="mb-4 text-lg font-bold dark:text-white">
          Update Service
        </h3>

        <div className="grid grid-cols-1 gap-3">
          <Input
            label="First Payment Amount"
            name="firstpaymentamount"
            type="number"
            value={form.firstpaymentamount}
            onChange={handleChange}
          />
          <Input
            label="Recurring Amount"
            name="recurringamount"
            type="number"
            value={form.recurringamount}
            onChange={handleChange}
          />
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Billing Cycle
            </label>

            <select
              name="billingcycle"
              value={form.billingcycle}
              onChange={handleChange}
              className="
      w-full px-3 py-2 text-sm
      border rounded-md
      bg-white dark:bg-gray-800
      border-gray-300 dark:border-gray-700
      text-gray-900 dark:text-gray-100
      focus:outline-none focus:ring-2 focus:ring-indigo-500
    "
              required
            >
              <option value="">-- Select Billing Cycle --</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
            </select>
          </div>

          <Input
            label="Next Due Date"
            name="nextduedate"
            type="date"
            value={form.nextduedate}
            onChange={handleChange}
          />

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Service Status
            </label>

            <select
              name="status"
              value={form.status}
              onChange={handleChange}
              className="
      w-full px-3 py-2 text-sm
      border rounded-md
      bg-white dark:bg-gray-800
      border-gray-300 dark:border-gray-700
      text-gray-900 dark:text-gray-100
      focus:outline-none focus:ring-2 focus:ring-indigo-500
    "
              required
            >
              <option value="">-- Select Service Status --</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <Input
            label="Username (Router)"
            name="username"
            value={form.username}
            onChange={handleChange}
          />
          <Input
            label="Password (Router)"
            name="password"
            value={form.password}
            onChange={handleChange}
          />

          <div>
            <label className="text-xs text-gray-500">Notes</label>
            <textarea
              name="notes"
              value={form.notes}
              onChange={handleChange}
              rows="3"
              className="mt-1 w-full rounded border px-3 py-2 text-sm dark:bg-gray-800 dark:border-gray-700"
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="rounded bg-gray-200 px-4 py-2 text-sm dark:bg-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="rounded bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700"
          >
            {loading ? "Saving..." : "Update"}
          </button>
        </div>
      </motion.div>
    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <div>
      <label className="text-xs text-gray-500">{label}</label>
      <input
        {...props}
        className="mt-1 w-full rounded border px-3 py-2 text-sm dark:bg-gray-800 dark:border-gray-700"
      />
    </div>
  );
}
